import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { PageCTA } from '../components/PageCTA';
import { Layout, Smartphone, Share2, CheckCircle2, Link as LinkIcon, Zap, Target, Search, Settings, QrCode, RefreshCw, Layers, Image as ImageIcon, MessageCircle, TrendingUp, Star, Utensils, Flame, Coffee, ShoppingBag, ChevronRight, Plus } from 'lucide-react';
import { WireframeGlobe } from '../components/WireframeGlobe';
export function ServicesPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="pt-24" data-id="element-917">
      {/* Page Header */}
      <section className="py-24 bg-[#0a0a0a] relative overflow-hidden" data-id="element-918">
        <div className="absolute inset-0 bg-grid-pattern opacity-30 pointer-events-none" data-id="element-919"></div>
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[400px] bg-brand-emerald/15 blur-[120px] rounded-full pointer-events-none" data-id="element-920"></div>

        <div className="container mx-auto px-6 md:px-12 relative z-10 text-center max-w-4xl" data-id="element-921">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-922">
            <h1 className="text-5xl md:text-7xl font-black text-white mb-8 tracking-tighter" data-id="element-923">
              Infraestructura Digital{' '}
              <span className="text-gradient" data-id="element-924">Integral</span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-400 leading-relaxed font-medium" data-id="element-925">
              Desarrollamos ecosistemas interconectados. Tu plataforma web,
              catálogos interactivos y canales de adquisición social operan en
              sincronía absoluta para maximizar la conversión 24/7.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Service 1: Web */}
      <section className="py-24 bg-[#050505] relative" data-id="element-926">
        <div className="section-divider absolute top-0" data-id="element-927"></div>
        <div className="absolute inset-0 bg-noise opacity-[0.02] mix-blend-overlay pointer-events-none" data-id="element-928"></div>

        <div className="container mx-auto px-6 md:px-12 max-w-7xl relative z-10" data-id="element-929">
          <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center" data-id="element-930">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="w-full lg:w-1/2" data-id="element-931">
              <div className="icon-premium mb-8 w-20 h-20" data-id="element-932">
                <Layout size={40} data-id="element-933" />
              </div>
              <h2 className="text-4xl md:text-5xl font-black text-white mb-8 tracking-tighter" data-id="element-934">
                Plataformas Web de Alto Rendimiento
              </h2>
              <div className="space-y-6 text-gray-400 text-lg leading-relaxed font-medium mb-8" data-id="element-935">
                <p data-id="element-936">
                  Tu plataforma web es el núcleo de tu infraestructura digital.
                  Implementamos arquitecturas de información avanzadas y
                  experiencias sin fricción diseñadas con precisión algorítmica
                  para transformar tráfico en ingresos predecibles.
                </p>
                <div className="bg-white/5 border border-white/10 rounded-xl p-5 flex gap-4" data-id="element-937">
                  <div className="shrink-0 mt-1" data-id="element-938">
                    <CheckCircle2 className="text-brand-emerald" size={24} data-id="element-939" />
                  </div>
                  <p className="text-base" data-id="element-940">
                    <strong className="text-white" data-id="element-941">100% a medida.</strong> No
                    usamos plantillas. Adaptamos tus ideas a la realidad
                    digital, construyendo desde cero una plataforma exclusiva
                    que refleja la verdadera calidad de tu negocio.
                  </p>
                </div>
              </div>

              <div className="flex flex-wrap gap-3" data-id="element-942">
                <span className="inline-flex items-center px-4 py-2 rounded-full bg-white/5 border border-white/10 text-gray-300 text-xs font-bold uppercase tracking-wider" data-id="element-943">
                  <span className="w-2 h-2 rounded-full bg-brand-emerald mr-2" data-id="element-944"></span>
                  SEO Optimizado
                </span>
                <span className="inline-flex items-center px-4 py-2 rounded-full bg-white/5 border border-white/10 text-gray-300 text-xs font-bold uppercase tracking-wider" data-id="element-945">
                  <span className="w-2 h-2 rounded-full bg-brand-emerald mr-2" data-id="element-946"></span>
                  Mobile First
                </span>
                <span className="inline-flex items-center px-4 py-2 rounded-full bg-brand-emerald/10 border border-brand-emerald/20 text-brand-emerald text-xs font-bold uppercase tracking-wider" data-id="element-947">
                  Conversión +120%
                </span>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="w-full lg:w-1/2" data-id="element-948">
              {/* Visual Browser Mockup */}
              <div className="bg-gradient-to-br from-[#111] to-[#0a0a0a] border border-white/10 rounded-2xl overflow-hidden shadow-[0_0_40px_rgba(16,185,129,0.05)]" data-id="element-949">
                {/* Browser Chrome */}
                <div className="bg-[#1a1a1a] border-b border-white/5 px-4 py-3 flex items-center gap-4" data-id="element-950">
                  <div className="flex gap-2" data-id="element-951">
                    <div className="w-3 h-3 rounded-full bg-red-500/50" data-id="element-952"></div>
                    <div className="w-3 h-3 rounded-full bg-yellow-500/50" data-id="element-953"></div>
                    <div className="w-3 h-3 rounded-full bg-green-500/50" data-id="element-954"></div>
                  </div>
                  <div className="flex-1 bg-black/50 rounded-md h-6 border border-white/5 flex items-center px-3" data-id="element-955">
                    <div className="w-4 h-4 text-gray-500 mr-2" data-id="element-956">
                      <Search size={12} data-id="element-957" />
                    </div>
                    <div className="w-32 h-2 bg-white/10 rounded-full" data-id="element-958"></div>
                  </div>
                </div>

                {/* Browser Content */}
                <div className="p-8 relative" data-id="element-959">
                  <div className="absolute top-0 right-0 w-64 h-64 bg-brand-emerald/5 blur-[60px] rounded-full pointer-events-none" data-id="element-960"></div>

                  <div className="flex items-center justify-between mb-8 relative z-10" data-id="element-961">
                    <div data-id="element-962">
                      <div className="text-sm font-bold text-gray-400 uppercase tracking-wider mb-1" data-id="element-963">
                        Crecimiento de Conversión
                      </div>
                      <div className="text-3xl font-black text-white" data-id="element-964">
                        +124%
                      </div>
                    </div>
                    <div className="w-12 h-12 rounded-xl bg-brand-emerald/10 flex items-center justify-center text-brand-emerald border border-brand-emerald/20" data-id="element-965">
                      <Target size={24} data-id="element-966" />
                    </div>
                  </div>

                  {/* Animated Chart */}
                  <div className="h-40 flex items-end gap-3 mb-8 relative z-10" data-id="element-967">
                    {[30, 45, 40, 65, 80, 100].map((height, i) => <div key={i} className="flex-1 flex flex-col justify-end h-full group" data-id="element-968">
                        <motion.div initial={{
                      height: 0
                    }} whileInView={{
                      height: `${height}%`
                    }} viewport={{
                      once: true
                    }} transition={{
                      duration: 0.8,
                      delay: 0.2 + i * 0.1,
                      ease: 'easeOut'
                    }} className="w-full bg-gradient-to-t from-brand-emerald/80 to-brand-emeraldLight/80 rounded-t-md relative" data-id="element-969">
                          <div className="absolute -top-8 left-1/2 -translate-x-1/2 bg-white text-black text-xs font-bold py-1 px-2 rounded opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-970">
                            {height}%
                          </div>
                        </motion.div>
                      </div>)}

                    {/* Overlay Line Chart */}
                    <svg className="absolute inset-0 w-full h-full pointer-events-none" preserveAspectRatio="none" data-id="element-971">
                      <motion.path initial={{
                      pathLength: 0
                    }} whileInView={{
                      pathLength: 1
                    }} viewport={{
                      once: true
                    }} transition={{
                      duration: 1.5,
                      delay: 0.5,
                      ease: 'easeInOut'
                    }} d="M 10 100 Q 50 80 90 90 T 170 50 T 250 20 T 330 0" fill="none" stroke="#fff" strokeWidth="2" strokeDasharray="4 4" className="drop-shadow-[0_0_5px_rgba(255,255,255,0.5)]" data-id="element-972" />
                    </svg>
                  </div>

                  {/* Stat Pills */}
                  <div className="flex flex-wrap gap-3 relative z-10" data-id="element-973">
                    <div className="bg-white/5 border border-white/10 rounded-full px-4 py-2 flex items-center gap-2 text-sm font-medium text-gray-300" data-id="element-974">
                      <Zap size={14} className="text-brand-emerald" data-id="element-975" /> Carga
                      &lt;1s
                    </div>
                    <div className="bg-white/5 border border-white/10 rounded-full px-4 py-2 flex items-center gap-2 text-sm font-medium text-gray-300" data-id="element-976">
                      <Search size={14} className="text-brand-emerald" data-id="element-977" /> SEO
                      95/100
                    </div>
                    <div className="bg-white/5 border border-white/10 rounded-full px-4 py-2 flex items-center gap-2 text-sm font-medium text-gray-300" data-id="element-978">
                      <Smartphone size={14} className="text-brand-emerald" data-id="element-979" />{' '}
                      Mobile 100%
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Service 2: Menu/Catalog */}
      <section className="py-24 bg-[#0a0a0a] relative" data-id="element-980">
        <div className="section-divider absolute top-0" data-id="element-981"></div>
        <div className="absolute inset-0 bg-grid-pattern opacity-20 pointer-events-none" data-id="element-982"></div>

        {/* Ambient background glow for the section */}
        <div className="absolute top-1/2 right-0 -translate-y-1/2 w-[800px] h-[800px] bg-brand-emerald/5 blur-[150px] rounded-full pointer-events-none" data-id="element-983"></div>

        <div className="container mx-auto px-6 md:px-12 max-w-7xl relative z-10" data-id="element-984">
          <div className="flex flex-col lg:flex-row-reverse gap-16 lg:gap-16 items-center" data-id="element-985">
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="w-full lg:w-1/2 relative" data-id="element-986">
              {/* Visual Phone Mockup */}
              <motion.div className="relative max-w-sm mx-auto" animate={{
              y: [-8, 8, -8]
            }} transition={{
              duration: 6,
              repeat: Infinity,
              ease: 'easeInOut'
            }} data-id="element-987">
                {/* Intense glow behind phone */}
                <div className="absolute -inset-10 bg-gradient-to-tr from-brand-emerald/20 via-brand-emerald/5 to-transparent blur-[50px] rounded-full pointer-events-none" data-id="element-988"></div>

                <div className="bg-[#0a0a0a] border-[8px] border-[#1a1a1a] rounded-[3rem] overflow-hidden relative shadow-[0_20px_50px_rgba(0,0,0,0.5),0_0_40px_rgba(16,185,129,0.15)] ring-1 ring-white/10" data-id="element-989">
                  {/* Phone Notch */}
                  <div className="absolute top-0 left-1/2 -translate-x-1/2 w-36 h-7 bg-[#1a1a1a] rounded-b-2xl z-30 flex justify-center items-center gap-2" data-id="element-990">
                    <div className="w-12 h-1.5 rounded-full bg-black/50" data-id="element-991"></div>
                    <div className="w-2 h-2 rounded-full bg-black/50" data-id="element-992"></div>
                  </div>

                  {/* Phone Header */}
                  <div className="bg-gradient-to-b from-[#1a1a1a] to-[#0f0f0f] pt-14 pb-5 px-6 border-b border-white/5 relative z-20 shadow-sm" data-id="element-993">
                    <div className="flex justify-between items-center mb-5" data-id="element-994">
                      <div className="w-10 h-10 rounded-full bg-brand-emerald/10 border border-brand-emerald/20 flex items-center justify-center text-brand-emerald shadow-[inset_0_0_10px_rgba(16,185,129,0.1)]" data-id="element-995">
                        <QrCode size={18} data-id="element-996" />
                      </div>
                      <div className="flex gap-3" data-id="element-997">
                        <div className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-white hover:bg-white/10 transition-colors" data-id="element-998">
                          <Search size={18} data-id="element-999" />
                        </div>
                        <div className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-white hover:bg-white/10 transition-colors relative" data-id="element-1000">
                          <ShoppingBag size={18} data-id="element-1001" />
                          {/* Cart Badge */}
                          <motion.div className="absolute -top-1 -right-1 w-4 h-4 rounded-full bg-brand-emerald border-2 border-[#151515] flex items-center justify-center" animate={{
                          scale: [1, 1.2, 1]
                        }} transition={{
                          duration: 2,
                          repeat: Infinity
                        }} data-id="element-1002">
                            <span className="text-[8px] font-bold text-[#0a0a0a]" data-id="element-1003">
                              2
                            </span>
                          </motion.div>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-end justify-between" data-id="element-1004">
                      <div data-id="element-1005">
                        <div className="text-white font-black text-2xl mb-1 tracking-tight" data-id="element-1006">
                          Nuestra Carta
                        </div>
                        <div className="flex items-center gap-2" data-id="element-1007">
                          <span className="w-2 h-2 rounded-full bg-brand-emerald animate-pulse" data-id="element-1008"></span>
                          <span className="text-brand-emerald text-xs font-bold uppercase tracking-widest" data-id="element-1009">
                            Mesa 12 · Activa
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Phone Content (Animated Menu Items) */}
                  <div className="p-5 space-y-3 bg-[#0a0a0a] h-[380px] relative z-10 overflow-hidden" data-id="element-1010">
                    {[{
                    name: 'Hamburguesa Trufada',
                    desc: 'Carne dry aged, queso brie',
                    price: '14,00€',
                    icon: <Flame size={18} className="text-orange-400" data-id="element-1011" />,
                    gradient: 'from-orange-500/20 to-red-500/5',
                    border: 'border-orange-500/20',
                    highlight: true
                  }, {
                    name: 'Pizza Gourmet',
                    desc: 'Masa madre, burrata, miel',
                    price: '16,00€',
                    icon: <Utensils size={18} className="text-yellow-400" data-id="element-1012" />,
                    gradient: 'from-yellow-500/20 to-amber-500/5',
                    border: 'border-yellow-500/20',
                    highlight: false
                  }, {
                    name: 'Tacos de Costilla',
                    desc: 'Cocción lenta 24h, pico de gallo',
                    price: '12,00€',
                    icon: <Flame size={18} className="text-red-400" data-id="element-1013" />,
                    gradient: 'from-red-500/20 to-rose-500/5',
                    border: 'border-red-500/20',
                    highlight: false
                  }, {
                    name: 'Tarta de Queso',
                    desc: 'Fluida, toque de pistacho',
                    price: '8,00€',
                    icon: <Coffee size={18} className="text-amber-700" data-id="element-1014" />,
                    gradient: 'from-amber-700/20 to-yellow-900/5',
                    border: 'border-amber-700/20',
                    highlight: false
                  }].map((item, i) => <motion.div key={i} initial={{
                    opacity: 0,
                    y: 20
                  }} whileInView={{
                    opacity: 1,
                    y: 0
                  }} viewport={{
                    once: true
                  }} transition={{
                    duration: 0.5,
                    delay: 0.2 + i * 0.15
                  }} className={`flex items-center gap-4 p-3.5 rounded-2xl transition-all duration-300 group cursor-pointer relative overflow-hidden ${item.highlight ? 'bg-white/[0.04] border-white/[0.08] shadow-[0_4px_20px_rgba(0,0,0,0.3)]' : 'bg-white/[0.02] border-white/[0.04] hover:bg-white/[0.04] hover:border-white/[0.08]'} border`} data-id="element-1015">
                        {item.highlight && <div className="absolute inset-0 bg-gradient-to-r from-brand-emerald/5 to-transparent opacity-50 pointer-events-none" data-id="element-1016"></div>}
                        <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${item.gradient} border ${item.border} shrink-0 flex items-center justify-center relative shadow-inner`} data-id="element-1017">
                          {item.icon}
                        </div>
                        <div className="flex-1 min-w-0" data-id="element-1018">
                          <div className="text-white font-bold text-[15px] truncate mb-0.5 group-hover:text-brand-emerald transition-colors" data-id="element-1019">
                            {item.name}
                          </div>
                          <div className="text-gray-400 text-[12px] truncate font-medium" data-id="element-1020">
                            {item.desc}
                          </div>
                        </div>
                        <div className="flex flex-col items-end gap-1 shrink-0" data-id="element-1021">
                          <div className="text-white font-bold text-[15px] tabular-nums" data-id="element-1022">
                            {item.price}
                          </div>
                          <div className={`w-6 h-6 rounded-full flex items-center justify-center transition-colors ${item.highlight ? 'bg-brand-emerald text-[#0a0a0a]' : 'bg-white/10 text-white group-hover:bg-brand-emerald group-hover:text-[#0a0a0a]'}`} data-id="element-1023">
                            <Plus size={14} strokeWidth={3} data-id="element-1024" />
                          </div>
                        </div>
                      </motion.div>)}

                    {/* Fade out bottom */}
                    <div className="absolute bottom-0 left-0 right-0 h-28 bg-gradient-to-t from-[#0a0a0a] via-[#0a0a0a]/80 to-transparent pointer-events-none z-20" data-id="element-1025"></div>
                  </div>
                </div>

                {/* Floating Stat Pills - Desktop only */}
                <div className="hidden md:block" data-id="element-1026">
                  <motion.div initial={{
                  opacity: 0,
                  x: 20,
                  y: 10
                }} whileInView={{
                  opacity: 1,
                  x: 0,
                  y: 0
                }} viewport={{
                  once: true
                }} transition={{
                  delay: 0.8,
                  type: 'spring',
                  stiffness: 100
                }} className="absolute top-28 -right-16 bg-[#111]/80 backdrop-blur-md border border-white/10 rounded-2xl p-3.5 shadow-[0_10px_30px_rgba(0,0,0,0.5)] flex items-center gap-3 z-30" data-id="element-1027">
                    <div className="relative" data-id="element-1028">
                      <motion.div className="absolute inset-0 bg-brand-emerald/30 rounded-full blur-sm" animate={{
                      scale: [1, 1.5, 1],
                      opacity: [0.5, 0, 0.5]
                    }} transition={{
                      duration: 2,
                      repeat: Infinity
                    }} data-id="element-1029" />
                      <div className="w-9 h-9 rounded-full bg-brand-emerald/20 border border-brand-emerald/30 flex items-center justify-center text-brand-emerald relative z-10" data-id="element-1030">
                        <RefreshCw size={16} data-id="element-1031" />
                      </div>
                    </div>
                    <div className="text-[11px] font-bold text-white uppercase tracking-wider leading-tight pr-2" data-id="element-1032">
                      Actualización
                      <br data-id="element-1033" />
                      <span className="text-gray-400" data-id="element-1034">Instantánea</span>
                    </div>
                  </motion.div>

                  <motion.div initial={{
                  opacity: 0,
                  x: -20,
                  y: -10
                }} whileInView={{
                  opacity: 1,
                  x: 0,
                  y: 0
                }} viewport={{
                  once: true
                }} transition={{
                  delay: 1,
                  type: 'spring',
                  stiffness: 100
                }} className="absolute bottom-32 -left-16 bg-[#111]/80 backdrop-blur-md border border-white/10 rounded-2xl p-3.5 shadow-[0_10px_30px_rgba(0,0,0,0.5)] flex items-center gap-3 z-30" data-id="element-1035">
                    <div className="relative" data-id="element-1036">
                      <motion.div className="absolute inset-0 bg-brand-emerald/30 rounded-full blur-sm" animate={{
                      scale: [1, 1.5, 1],
                      opacity: [0.5, 0, 0.5]
                    }} transition={{
                      duration: 2,
                      repeat: Infinity,
                      delay: 1
                    }} data-id="element-1037" />
                      <div className="w-9 h-9 rounded-full bg-brand-emerald/20 border border-brand-emerald/30 flex items-center justify-center text-brand-emerald relative z-10" data-id="element-1038">
                        <Settings size={16} data-id="element-1039" />
                      </div>
                    </div>
                    <div className="text-[11px] font-bold text-white uppercase tracking-wider leading-tight pr-2" data-id="element-1040">
                      100%
                      <br data-id="element-1041" />
                      <span className="text-gray-400" data-id="element-1042">Personalizable</span>
                    </div>
                  </motion.div>
                </div>
              </motion.div>

              {/* Mobile Stat Pills */}
              <div className="flex md:hidden flex-wrap justify-center gap-4 mt-10" data-id="element-1043">
                <div className="bg-[#111]/80 backdrop-blur-md border border-white/10 rounded-2xl p-3 shadow-xl flex items-center gap-3" data-id="element-1044">
                  <div className="w-8 h-8 rounded-full bg-brand-emerald/20 flex items-center justify-center text-brand-emerald" data-id="element-1045">
                    <RefreshCw size={14} data-id="element-1046" />
                  </div>
                  <div className="text-xs font-bold text-white" data-id="element-1047">
                    Actualización
                    <br data-id="element-1048" />
                    <span className="text-gray-400" data-id="element-1049">Instantánea</span>
                  </div>
                </div>
                <div className="bg-[#111]/80 backdrop-blur-md border border-white/10 rounded-2xl p-3 shadow-xl flex items-center gap-3" data-id="element-1050">
                  <div className="w-8 h-8 rounded-full bg-brand-emerald/20 flex items-center justify-center text-brand-emerald" data-id="element-1051">
                    <Settings size={14} data-id="element-1052" />
                  </div>
                  <div className="text-xs font-bold text-white" data-id="element-1053">
                    100%
                    <br data-id="element-1054" />
                    <span className="text-gray-400" data-id="element-1055">Personalizable</span>
                  </div>
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="w-full lg:w-1/2" data-id="element-1056">
              <motion.div className="icon-premium mb-8 w-20 h-20 relative" animate={{
              boxShadow: ['inset 0 0 20px rgba(16,185,129,0.1)', 'inset 0 0 30px rgba(16,185,129,0.3)', 'inset 0 0 20px rgba(16,185,129,0.1)']
            }} transition={{
              duration: 3,
              repeat: Infinity
            }} data-id="element-1057">
                <Smartphone size={40} data-id="element-1058" />
              </motion.div>
              <h2 className="text-4xl md:text-5xl font-black text-white mb-8 tracking-tighter" data-id="element-1059">
                Menús Digitales Avanzados
              </h2>
              <div className="space-y-6 text-gray-400 text-lg leading-relaxed font-medium mb-10" data-id="element-1060">
                <p data-id="element-1061">
                  Creamos menús digitales avanzados y 100% personalizables a las
                  necesidades de tu negocio. Acceso instantáneo vía QR,
                  actualizaciones en tiempo real y presentación visual de alto
                  impacto que maximiza la interacción del cliente.
                </p>
                <div className="bg-gradient-to-r from-brand-emerald/10 to-white/[0.02] border border-white/10 border-l-2 border-l-brand-emerald rounded-xl p-6 flex gap-5 shadow-[0_10px_30px_rgba(0,0,0,0.2)]" data-id="element-1062">
                  <div className="shrink-0 mt-0.5" data-id="element-1063">
                    <div className="w-8 h-8 rounded-full bg-brand-emerald/20 flex items-center justify-center text-brand-emerald" data-id="element-1064">
                      <CheckCircle2 size={18} data-id="element-1065" />
                    </div>
                  </div>
                  <p className="text-base text-gray-300" data-id="element-1066">
                    <strong className="text-white font-bold" data-id="element-1067">
                      Diseño exclusivo.
                    </strong>{' '}
                    Cada elemento visual se diseña pensando en tu marca.
                    Mejoramos la percepción de valor de tus productos para
                    aumentar el ticket medio de tus clientes.
                  </p>
                </div>
              </div>

              <div className="flex flex-wrap gap-3" data-id="element-1068">
                {[{
                text: 'Acceso QR',
                delay: 0.2
              }, {
                text: '100% Personalizable',
                delay: 0.3
              }, {
                text: 'Interacción +3x',
                delay: 0.4,
                highlight: true
              }].map((pill, idx) => <motion.span key={idx} initial={{
                opacity: 0,
                y: 10
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: pill.delay,
                duration: 0.4
              }} className={`inline-flex items-center px-5 py-2.5 rounded-full text-xs font-bold uppercase tracking-wider shadow-sm ${pill.highlight ? 'bg-brand-emerald/10 border border-brand-emerald/30 text-brand-emerald' : 'bg-white/5 border border-white/10 text-gray-300'}`} data-id="element-1069">
                    {!pill.highlight && <span className="w-2 h-2 rounded-full bg-brand-emerald mr-2.5 shadow-[0_0_8px_rgba(16,185,129,0.8)]" data-id="element-1070"></span>}
                    {pill.text}
                  </motion.span>)}
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Service 3: Social */}
      <section className="py-24 bg-[#050505] relative" data-id="element-1071">
        <div className="section-divider absolute top-0" data-id="element-1072"></div>
        <div className="absolute inset-0 bg-noise opacity-[0.02] mix-blend-overlay pointer-events-none" data-id="element-1073"></div>

        {/* Ambient background glow for the section */}
        <div className="absolute top-1/2 left-0 -translate-y-1/2 w-[800px] h-[800px] bg-brand-emerald/5 blur-[150px] rounded-full pointer-events-none" data-id="element-1074"></div>

        <div className="container mx-auto px-6 md:px-12 max-w-7xl relative z-10" data-id="element-1075">
          <div className="flex flex-col lg:flex-row gap-16 lg:gap-16 items-center" data-id="element-1076">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="w-full lg:w-1/2" data-id="element-1077">
              <div className="icon-premium mb-8 w-20 h-20" data-id="element-1078">
                <Share2 size={40} data-id="element-1079" />
              </div>
              <h2 className="text-4xl md:text-5xl font-black text-white mb-8 tracking-tighter" data-id="element-1080">
                Ecosistemas Sociales Conectados
              </h2>
              <div className="space-y-6 text-gray-400 text-lg leading-relaxed font-medium mb-10" data-id="element-1081">
                <p data-id="element-1082">
                  Creamos y configuramos tus perfiles en redes sociales,
                  sincronizados con tu página web para una imagen profesional y
                  coherente. Tus redes actúan como imanes de atención que
                  canalizan usuarios hacia tu infraestructura principal.
                </p>
                <div className="bg-gradient-to-r from-brand-emerald/10 to-white/[0.02] border border-white/10 border-l-2 border-l-brand-emerald rounded-xl p-6 flex gap-5 shadow-[0_10px_30px_rgba(0,0,0,0.2)]" data-id="element-1083">
                  <div className="shrink-0 mt-0.5" data-id="element-1084">
                    <div className="w-8 h-8 rounded-full bg-brand-emerald/20 flex items-center justify-center text-brand-emerald" data-id="element-1085">
                      <CheckCircle2 size={18} data-id="element-1086" />
                    </div>
                  </div>
                  <p className="text-base text-gray-300" data-id="element-1087">
                    <strong className="text-white font-bold" data-id="element-1088">
                      Reputación digital impecable.
                    </strong>{' '}
                    Aseguramos que la primera impresión de tus clientes sea
                    perfecta. Transmitimos confianza absoluta desde el primer
                    punto de contacto.
                  </p>
                </div>
              </div>

              <div className="flex flex-wrap gap-3" data-id="element-1089">
                {[{
                text: 'Imagen Coherente',
                delay: 0.2
              }, {
                text: 'Sincronización Web',
                delay: 0.3
              }, {
                text: 'Alcance +85%',
                delay: 0.4,
                highlight: true
              }].map((pill, idx) => <motion.span key={idx} initial={{
                opacity: 0,
                y: 10
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: pill.delay,
                duration: 0.4
              }} className={`inline-flex items-center px-5 py-2.5 rounded-full text-xs font-bold uppercase tracking-wider shadow-sm ${pill.highlight ? 'bg-brand-emerald/10 border border-brand-emerald/30 text-brand-emerald' : 'bg-white/5 border border-white/10 text-gray-300'}`} data-id="element-1090">
                    {!pill.highlight && <span className="w-2 h-2 rounded-full bg-brand-emerald mr-2.5 shadow-[0_0_8px_rgba(16,185,129,0.8)]" data-id="element-1091"></span>}
                    {pill.text}
                  </motion.span>)}
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="w-full lg:w-1/2 relative" data-id="element-1092">
              {/* Dashboard Mockup */}
              <div className="relative max-w-lg mx-auto" data-id="element-1093">
                {/* Subtle glow behind dashboard */}
                <div className="absolute -inset-4 bg-brand-emerald/5 blur-[30px] rounded-3xl pointer-events-none" data-id="element-1094"></div>

                <div className="bg-[#0a0a0a] border border-white/10 rounded-2xl overflow-hidden shadow-[0_20px_50px_rgba(0,0,0,0.5)] relative z-10" data-id="element-1095">
                  {/* Dashboard Header */}
                  <div className="bg-[#111] border-b border-white/5 px-6 py-4 flex items-center justify-between" data-id="element-1096">
                    <div className="flex items-center gap-3" data-id="element-1097">
                      <div className="w-8 h-8 rounded-lg bg-brand-emerald/10 border border-brand-emerald/20 flex items-center justify-center text-brand-emerald" data-id="element-1098">
                        <Share2 size={16} data-id="element-1099" />
                      </div>
                      <div data-id="element-1100">
                        <div className="text-white font-bold text-sm tracking-wide" data-id="element-1101">
                          Ecosistema Social
                        </div>
                        <div className="text-gray-500 text-[10px] uppercase tracking-widest font-medium" data-id="element-1102">
                          Panel de Control
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-emerald/10 border border-brand-emerald/20" data-id="element-1103">
                      <motion.div className="w-1.5 h-1.5 rounded-full bg-brand-emerald" animate={{
                      opacity: [0.5, 1, 0.5]
                    }} transition={{
                      duration: 2,
                      repeat: Infinity,
                      ease: 'easeInOut'
                    }} data-id="element-1104" />
                      <span className="text-brand-emerald text-[10px] font-bold uppercase tracking-wider" data-id="element-1105">
                        Activo
                      </span>
                    </div>
                  </div>

                  {/* Dashboard Content */}
                  <div className="p-6 bg-[#0a0a0a]" data-id="element-1106">
                    {/* Social Cards */}
                    <div className="space-y-3 mb-6" data-id="element-1107">
                      {[{
                      name: 'Instagram',
                      icon: <ImageIcon size={16} className="text-white" data-id="element-1108" />,
                      gradient: 'from-purple-600 via-pink-500 to-orange-500',
                      delay: 0.2
                    }, {
                      name: 'Facebook',
                      icon: <Share2 size={16} className="text-white" data-id="element-1109" />,
                      gradient: 'from-blue-600 to-blue-400',
                      delay: 0.3
                    }, {
                      name: 'WhatsApp Business',
                      icon: <MessageCircle size={16} className="text-white" data-id="element-1110" />,
                      gradient: 'from-green-600 to-green-400',
                      delay: 0.4
                    }].map((platform, i) => <motion.div key={i} initial={{
                      opacity: 0,
                      y: 10
                    }} whileInView={{
                      opacity: 1,
                      y: 0
                    }} viewport={{
                      once: true
                    }} transition={{
                      delay: platform.delay,
                      duration: 0.4
                    }} className="flex items-center justify-between p-4 rounded-xl bg-[#111] border border-white/5 hover:bg-white/[0.04] transition-colors" data-id="element-1111">
                          <div className="flex items-center gap-4" data-id="element-1112">
                            <div className={`w-10 h-10 rounded-lg bg-gradient-to-br ${platform.gradient} flex items-center justify-center shadow-inner`} data-id="element-1113">
                              {platform.icon}
                            </div>
                            <div className="text-white font-medium text-sm" data-id="element-1114">
                              {platform.name}
                            </div>
                          </div>
                          <div className="flex items-center gap-2" data-id="element-1115">
                            <span className="text-gray-400 text-xs" data-id="element-1116">
                              Conectado
                            </span>
                            <motion.div className="w-2 h-2 rounded-full bg-brand-emerald" animate={{
                          opacity: [0.5, 1, 0.5]
                        }} transition={{
                          duration: 2,
                          repeat: Infinity,
                          ease: 'easeInOut',
                          delay: i * 0.5 // Stagger the pulses slightly
                        }} data-id="element-1117" />
                          </div>
                        </motion.div>)}
                    </div>

                    {/* Metrics Row */}
                    <div className="grid grid-cols-3 gap-3 mb-6" data-id="element-1118">
                      <motion.div initial={{
                      opacity: 0,
                      y: 10
                    }} whileInView={{
                      opacity: 1,
                      y: 0
                    }} viewport={{
                      once: true
                    }} transition={{
                      delay: 0.5,
                      duration: 0.4
                    }} className="p-4 rounded-xl bg-[#111] border border-white/5 flex flex-col items-center justify-center text-center" data-id="element-1119">
                        <TrendingUp size={16} className="text-brand-emerald mb-2" data-id="element-1120" />
                        <div className="text-white font-bold text-lg mb-0.5" data-id="element-1121">
                          +85%
                        </div>
                        <div className="text-gray-500 text-[10px] uppercase tracking-wider" data-id="element-1122">
                          Alcance
                        </div>
                      </motion.div>
                      <motion.div initial={{
                      opacity: 0,
                      y: 10
                    }} whileInView={{
                      opacity: 1,
                      y: 0
                    }} viewport={{
                      once: true
                    }} transition={{
                      delay: 0.6,
                      duration: 0.4
                    }} className="p-4 rounded-xl bg-[#111] border border-white/5 flex flex-col items-center justify-center text-center" data-id="element-1123">
                        <Zap size={16} className="text-brand-emerald mb-2" data-id="element-1124" />
                        <div className="text-white font-bold text-lg mb-0.5" data-id="element-1125">
                          3x
                        </div>
                        <div className="text-gray-500 text-[10px] uppercase tracking-wider" data-id="element-1126">
                          Engagement
                        </div>
                      </motion.div>
                      <motion.div initial={{
                      opacity: 0,
                      y: 10
                    }} whileInView={{
                      opacity: 1,
                      y: 0
                    }} viewport={{
                      once: true
                    }} transition={{
                      delay: 0.7,
                      duration: 0.4
                    }} className="p-4 rounded-xl bg-[#111] border border-white/5 flex flex-col items-center justify-center text-center" data-id="element-1127">
                        <RefreshCw size={16} className="text-brand-emerald mb-2" data-id="element-1128" />
                        <div className="text-white font-bold text-lg mb-0.5" data-id="element-1129">
                          100%
                        </div>
                        <div className="text-gray-500 text-[10px] uppercase tracking-wider" data-id="element-1130">
                          Sincronizado
                        </div>
                      </motion.div>
                    </div>

                    {/* Bottom Bar */}
                    <motion.div initial={{
                    opacity: 0,
                    y: 10
                  }} whileInView={{
                    opacity: 1,
                    y: 0
                  }} viewport={{
                    once: true
                  }} transition={{
                    delay: 0.8,
                    duration: 0.4
                  }} className="p-4 rounded-xl bg-brand-emerald/5 border border-brand-emerald/10 flex items-center justify-between" data-id="element-1131">
                      <div className="flex items-center gap-3" data-id="element-1132">
                        <LinkIcon size={16} className="text-brand-emerald" data-id="element-1133" />
                        <span className="text-gray-300 text-sm font-medium" data-id="element-1134">
                          Sincronizado con tu web
                        </span>
                      </div>
                      <span className="text-gray-500 text-xs" data-id="element-1135">
                        www.tunegocio.com
                      </span>
                    </motion.div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="py-24 bg-[#0a0a0a] relative overflow-hidden" data-id="element-1136">
        <div className="section-divider absolute top-0" data-id="element-1137"></div>
        <div className="absolute inset-0 bg-grid-pattern-emerald opacity-5 pointer-events-none" data-id="element-1138"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-[300px] bg-brand-emerald/10 blur-[100px] rounded-full pointer-events-none" data-id="element-1139"></div>

        <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-1140">
          <div className="max-w-5xl mx-auto" data-id="element-1141">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-center mb-16" data-id="element-1142">
              <h2 className="text-4xl md:text-5xl font-black text-white mb-6 tracking-tighter" data-id="element-1143">
                Un ecosistema completo,{' '}
                <span className="text-gradient" data-id="element-1144">un precio único</span>
              </h2>
              <p className="text-gray-400 text-xl font-medium max-w-3xl mx-auto" data-id="element-1145">
                Transparencia absoluta. Sin cuotas ocultas ni sorpresas.
                Diseñamos tu infraestructura digital completa desde cero con un
                modelo de pago basado en la confianza y resultados.
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} className="bg-gradient-to-br from-[#111] to-[#0a1a12] border border-brand-emerald/30 rounded-[2.5rem] p-8 md:p-16 shadow-[0_0_50px_rgba(16,185,129,0.15)] relative overflow-hidden" data-id="element-1146">
              <div className="absolute top-0 right-0 w-96 h-96 bg-brand-emerald/10 blur-[100px] rounded-full pointer-events-none" data-id="element-1147"></div>
              <div className="absolute top-0 inset-x-0 h-1 bg-gradient-to-r from-transparent via-brand-emerald to-transparent opacity-50" data-id="element-1148"></div>

              <div className="flex flex-col lg:flex-row items-center justify-between gap-12 lg:gap-20 relative z-10" data-id="element-1149">
                {/* Price Display */}
                <div className="text-center lg:text-left w-full lg:w-auto flex flex-col items-center lg:items-start" data-id="element-1150">
                  <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-emerald/10 border border-brand-emerald/20 text-brand-emerald text-xs font-bold uppercase tracking-widest mb-6" data-id="element-1151">
                    <Star size={14} data-id="element-1152" /> Oferta Integral
                  </div>
                  <div className="relative" data-id="element-1153">
                    <div className="absolute inset-0 bg-brand-emerald/20 blur-2xl rounded-full" data-id="element-1154"></div>
                    <div className="text-7xl md:text-8xl lg:text-9xl font-black text-transparent bg-clip-text bg-gradient-to-br from-white to-gray-400 tracking-tighter mb-2 relative z-10 drop-shadow-lg" data-id="element-1155">
                      350€
                    </div>
                  </div>
                  <div className="text-gray-400 font-medium text-lg mt-4" data-id="element-1156">
                    Precio total cerrado
                  </div>
                </div>

                <div className="hidden lg:block w-px h-48 bg-gradient-to-b from-transparent via-white/10 to-transparent" data-id="element-1157"></div>
                <div className="block lg:hidden w-full h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" data-id="element-1158"></div>

                {/* Payment Steps */}
                <div className="flex-1 space-y-6 w-full" data-id="element-1159">
                  <div className="bg-[#0a0a0a]/50 p-6 md:p-8 rounded-2xl border border-white/5 flex flex-col sm:flex-row items-start sm:items-center gap-6 hover:border-white/10 transition-colors" data-id="element-1160">
                    <div className="w-16 h-16 rounded-2xl bg-white/5 flex items-center justify-center text-white text-2xl font-black shrink-0 border border-white/10 shadow-inner" data-id="element-1161">
                      50€
                    </div>
                    <div data-id="element-1162">
                      <h4 className="text-white font-bold text-xl mb-2" data-id="element-1163">
                        Pago Inicial
                      </h4>
                      <p className="text-gray-400 font-medium leading-relaxed" data-id="element-1164">
                        Abono anticipado para reservar. Comenzamos a trabajar el
                        mismo día.
                      </p>
                    </div>
                  </div>

                  <div className="bg-brand-emerald/5 p-6 md:p-8 rounded-2xl border border-brand-emerald/30 flex flex-col sm:flex-row items-start sm:items-center gap-6 shadow-[0_0_30px_rgba(16,185,129,0.1)] relative overflow-hidden group" data-id="element-1165">
                    <div className="absolute inset-0 bg-gradient-to-r from-brand-emerald/0 via-brand-emerald/5 to-brand-emerald/0 -translate-x-full group-hover:animate-[shimmer_2s_infinite]" data-id="element-1166"></div>
                    <div className="w-16 h-16 rounded-2xl bg-brand-emerald/20 flex items-center justify-center text-brand-emerald text-2xl font-black shrink-0 border border-brand-emerald/40 shadow-[0_0_15px_rgba(16,185,129,0.2)] relative z-10" data-id="element-1167">
                      300€
                    </div>
                    <div className="relative z-10" data-id="element-1168">
                      <h4 className="text-white font-bold text-xl mb-2" data-id="element-1169">
                        Pago Final
                      </h4>
                      <p className="text-brand-emerald/90 font-medium leading-relaxed" data-id="element-1170">
                        Solo cuando estés 100% satisfecho y cumplamos tus
                        expectativas.
                      </p>
                    </div>
                  </div>

                  {/* Trust Indicators */}
                  <div className="flex flex-wrap items-center justify-center lg:justify-start gap-x-6 gap-y-3 pt-6 border-t border-white/5" data-id="element-1171">
                    <div className="flex items-center gap-2 text-sm text-gray-400 font-medium" data-id="element-1172">
                      <CheckCircle2 size={16} className="text-brand-emerald" data-id="element-1173" />
                      <span data-id="element-1174">100% Personalizado</span>
                    </div>
                    <div className="flex items-center gap-2 text-sm text-gray-400 font-medium" data-id="element-1175">
                      <CheckCircle2 size={16} className="text-brand-emerald" data-id="element-1176" />
                      <span data-id="element-1177">Sin plantillas</span>
                    </div>
                    <div className="flex items-center gap-2 text-sm text-gray-400 font-medium" data-id="element-1178">
                      <CheckCircle2 size={16} className="text-brand-emerald" data-id="element-1179" />
                      <span data-id="element-1180">Transparencia absoluta</span>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Ecosystem Connection */}
      <section className="py-24 bg-[#0a0a0a] relative overflow-hidden" data-id="element-1181">
        <div className="section-divider absolute top-0" data-id="element-1182"></div>
        <div className="absolute inset-0 bg-grid-pattern opacity-20 pointer-events-none" data-id="element-1183"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-[400px] bg-brand-emerald/10 blur-[150px] rounded-full pointer-events-none" data-id="element-1184"></div>

        <div className="container mx-auto px-6 md:px-12 relative z-10 text-center" data-id="element-1185">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="max-w-3xl mx-auto mb-20" data-id="element-1186">
            <h2 className="text-4xl md:text-6xl font-black text-white mb-6 tracking-tighter" data-id="element-1187">
              Sincronización absoluta en un{' '}
              <span className="text-gradient" data-id="element-1188">entorno unificado</span>
            </h2>
            <p className="text-gray-400 text-xl font-medium" data-id="element-1189">
              La verdadera ventaja competitiva reside en la interconexión.
              Diseñamos una red donde cada nodo amplifica el rendimiento del
              sistema global.
            </p>
          </motion.div>

          <div className="relative max-w-4xl mx-auto" data-id="element-1190">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center" data-id="element-1191">
              {/* Left Column: Social Nodes */}
              <div className="flex flex-col gap-4 order-2 md:order-1" data-id="element-1192">
                <motion.div initial={{
                opacity: 0,
                x: -30
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: 0.2
              }} className="bg-[#111] border border-white/10 rounded-2xl p-5 flex items-center gap-4 shadow-lg group hover:border-brand-emerald/30 transition-colors" data-id="element-1193">
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-tr from-yellow-400 via-red-500 to-purple-500 flex items-center justify-center shrink-0" data-id="element-1194">
                    <ImageIcon size={20} className="text-white" data-id="element-1195" />
                  </div>
                  <div className="text-left" data-id="element-1196">
                    <div className="text-white font-bold" data-id="element-1197">Instagram</div>
                    <div className="text-xs text-gray-400" data-id="element-1198">Tráfico visual</div>
                  </div>
                </motion.div>

                <motion.div initial={{
                opacity: 0,
                x: -30
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: 0.3
              }} className="bg-[#111] border border-white/10 rounded-2xl p-5 flex items-center gap-4 shadow-lg group hover:border-brand-emerald/30 transition-colors" data-id="element-1199">
                  <div className="w-12 h-12 rounded-xl bg-blue-600 flex items-center justify-center shrink-0" data-id="element-1200">
                    <Share2 size={20} className="text-white" data-id="element-1201" />
                  </div>
                  <div className="text-left" data-id="element-1202">
                    <div className="text-white font-bold" data-id="element-1203">Facebook</div>
                    <div className="text-xs text-gray-400" data-id="element-1204">Comunidad local</div>
                  </div>
                </motion.div>

                <motion.div initial={{
                opacity: 0,
                x: -30
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: 0.4
              }} className="bg-[#111] border border-white/10 rounded-2xl p-5 flex items-center gap-4 shadow-lg group hover:border-brand-emerald/30 transition-colors" data-id="element-1205">
                  <div className="w-12 h-12 rounded-xl bg-black border border-white/20 flex items-center justify-center shrink-0" data-id="element-1206">
                    <MessageCircle size={20} className="text-white" data-id="element-1207" />
                  </div>
                  <div className="text-left" data-id="element-1208">
                    <div className="text-white font-bold" data-id="element-1209">TikTok</div>
                    <div className="text-xs text-gray-400" data-id="element-1210">Alcance viral</div>
                  </div>
                </motion.div>
              </div>

              {/* Center Column: Core Platform */}
              <div className="flex justify-center order-1 md:order-2 mb-8 md:mb-0 relative" data-id="element-1211">
                {/* Connecting lines for desktop */}
                <div className="hidden md:block absolute top-1/2 left-0 w-full h-px bg-gradient-to-r from-brand-emerald/50 via-brand-emerald to-brand-emerald/50 -translate-y-1/2 -z-10" data-id="element-1212"></div>

                <motion.div initial={{
                scale: 0.8,
                opacity: 0
              }} whileInView={{
                scale: 1,
                opacity: 1
              }} viewport={{
                once: true
              }} className="w-48 h-48 rounded-full bg-gradient-to-br from-[#111] to-[#0a1a12] border-2 border-brand-emerald flex flex-col items-center justify-center shadow-[0_0_50px_rgba(16,185,129,0.3)] relative group" data-id="element-1213">
                  <div className="absolute inset-0 bg-brand-emerald/10 rounded-full blur-md group-hover:bg-brand-emerald/20 transition-colors" data-id="element-1214"></div>
                  <div className="absolute inset-0 rounded-full border border-brand-emerald animate-[ping_3s_cubic-bezier(0,0,0.2,1)_infinite] opacity-30" data-id="element-1215"></div>
                  <Layout className="text-brand-emerald mb-3 relative z-10" size={40} data-id="element-1216" />
                  <span className="text-sm font-black text-white uppercase tracking-wider relative z-10" data-id="element-1217">
                    Web Core
                  </span>
                  <span className="text-[10px] text-brand-emerald/80 font-bold uppercase tracking-widest mt-1 relative z-10" data-id="element-1218">
                    Conversión
                  </span>
                </motion.div>
              </div>

              {/* Right Column: Results/Acquisition */}
              <div className="flex flex-col gap-4 order-3" data-id="element-1219">
                <motion.div initial={{
                opacity: 0,
                x: 30
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: 0.2
              }} className="bg-gradient-to-r from-brand-emerald/10 to-transparent border border-brand-emerald/20 rounded-2xl p-6 flex flex-col justify-center shadow-lg h-full" data-id="element-1220">
                  <div className="text-brand-emerald mb-2" data-id="element-1221">
                    <TrendingUp size={24} data-id="element-1222" />
                  </div>
                  <div className="text-3xl font-black text-white mb-1" data-id="element-1223">
                    +85%
                  </div>
                  <div className="text-sm text-gray-400 font-medium" data-id="element-1224">
                    Incremento en alcance orgánico
                  </div>
                </motion.div>

                <motion.div initial={{
                opacity: 0,
                x: 30
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: 0.3
              }} className="bg-gradient-to-r from-brand-emerald/10 to-transparent border border-brand-emerald/20 rounded-2xl p-6 flex flex-col justify-center shadow-lg h-full" data-id="element-1225">
                  <div className="text-brand-emerald mb-2" data-id="element-1226">
                    <Target size={24} data-id="element-1227" />
                  </div>
                  <div className="text-3xl font-black text-white mb-1" data-id="element-1228">3x</div>
                  <div className="text-sm text-gray-400 font-medium" data-id="element-1229">
                    Multiplicador de leads
                  </div>
                </motion.div>
              </div>
            </div>

            {/* Stat Pills */}
            <div className="flex flex-wrap justify-center gap-4 relative z-10 mt-12" data-id="element-1230">
              <div className="bg-white/5 border border-white/10 rounded-full px-5 py-2.5 flex items-center gap-2 text-sm font-medium text-gray-300" data-id="element-1231">
                <LinkIcon size={16} className="text-brand-emerald" data-id="element-1232" /> Perfiles
                Sincronizados
              </div>
              <div className="bg-white/5 border border-white/10 rounded-full px-5 py-2.5 flex items-center gap-2 text-sm font-medium text-gray-300" data-id="element-1233">
                <Target size={16} className="text-brand-emerald" data-id="element-1234" /> Imagen
                Coherente
              </div>
            </div>
          </div>
        </div>
      </section>

      <PageCTA data-id="element-1235" />
    </div>;
}